import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import { BooleanInput } from "react-admin";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  EditProps,
  useEditController,
  AutocompleteArrayInput,
} from "react-admin";

import { useGetList } from "react-admin";
import { Box } from "@mui/material";
import { DEPARTMENTS, validateOptionalUrl, validateDateRange } from "../../../constants";
import { WarningBox } from "./WarningBox";

export const EditJobOffer: React.FC<EditProps> = (props) => {
  const { record } = useEditController();
  const { data: categories = [], isLoading: isLoadingCategories } = useGetList("categories", {
    pagination: { page: 1, perPage: 100 },
  });

  const { data: statuses = [], isLoading: isLoadingStatuses } = useGetList("statuses");

  const title = record ? `Editando: ${record.title}` : "Editando oferta";

  return (
    <div>
      <WarningBox>
        <strong>Atención:</strong> Las ofertas que pasen al estado{" "}
        <em>
          <strong>"Recepción de postulaciones"</strong>
        </em>{" "}
        enviarán un correo electrónico a los postulantes que estén interesados
        en las categorías seleccionadas.
      </WarningBox>
      <Edit {...props} title={title} mutationMode="pessimistic">
        <SimpleForm>
          <TextInput source="title" fullWidth />
          <BooleanInput source="isFeatured" label="Oferta destacada" />
          <Box sx={{ display: "flex", gap: "16px" }}>
            <TextInput source="reference" label="Nº de referencia" />
            <DateInput
              source="startDate"
              label="Fecha de inicio"
              validate={(value, allValues) =>
                validateDateRange(value, allValues?.endDate)
              }
            />
            <DateInput
              source="endDate"
              label="Fecha de fin"
              validate={(value, allValues) =>
                validateDateRange(allValues?.startDate, value)
              }
            />
            <SelectInput
              source="statusId"
              choices={isLoadingStatuses ? [] : statuses}
              label="Estado"
              disabled={isLoadingStatuses}
            ></SelectInput>
            <TextInput source="slug" disabled />
          </Box>
          <Box sx={{ display: "flex", gap: "16px" }}>
            <TextInput source="address1" label="Dirección" />
            <SelectInput source="department" choices={DEPARTMENTS} />
          </Box>
          <Box sx={{ display: "flex", gap: "16px" }}>
            <TextInput
              source="workingHours"
              label="Horario laboral"
              fullWidth
            ></TextInput>
            <TextInput source="salary" label="Salario" fullWidth></TextInput>
          </Box>

          <TextInput
            source="companyLogoUrl"
            label="Logo de la empresa"
            fullWidth
            validate={(v) => (v ? validateOptionalUrl(v) : undefined)}
          ></TextInput>
          <AutocompleteArrayInput
            source="categories"
            choices={isLoadingCategories ? [] : categories}
            fullWidth
            label="Categorias"
            disabled={isLoadingCategories}
          ></AutocompleteArrayInput>

          <RichTextInput source="description" label="Descripcion" fullWidth />
        </SimpleForm>
      </Edit>
    </div>
  );
};
